var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJamaica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 39.9999C31.0456 39.9999 39.9999 31.0456 39.9999 19.9999C39.9999 8.95418 31.0456 -0.00012207 19.9999 -0.00012207C8.95418 -0.00012207 -0.00012207 8.95418 -0.00012207 19.9999C-0.00012207 31.0456 8.95418 39.9999 19.9999 39.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1762 4.13437C28.8038 1.54211 24.5823 0 19.9999 0C15.4176 0 11.196 1.54219 7.82361 4.13437L19.9999 16.3106L32.1762 4.13437Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1343 7.82385C1.54219 11.1963 0 15.4178 0 20.0001C0 24.5824 1.54219 28.804 4.13438 32.1765L16.3107 20.0001L4.1343 7.82385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82361 35.8657C11.1961 38.458 15.4176 40.0001 19.9999 40.0001C24.5823 40.0001 28.8038 38.4579 32.1763 35.8657L19.9999 23.6895L7.82361 35.8657Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8656 32.1764C38.4578 28.8039 40 24.5824 40 20.0001C40 15.4178 38.4578 11.1963 35.8656 7.82385L23.6893 20.0001L35.8656 32.1764Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamaica);
export default __webpack_public_path__ + "static/media/jamaica.cabba9abf04bc5e929af37230fa9c09c.svg";
export { ForwardRef as ReactComponent };